import { makeStyles, tokens, Text, Button } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalXL,
        textAlign: 'center',
    },
    successMessage: {
        textAlign: 'center',
        fontSize: tokens.fontSizeBase300,
        lineHeight: tokens.lineHeightBase300,
        backgroundColor: tokens.colorPaletteGreenBackground1,
        borderRadius: tokens.borderRadiusMedium,
        padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalL}`,
    },
});

interface CallbackSuccessProps {
    onClose: () => void;
}

export const CallbackSuccess: React.FC<CallbackSuccessProps> = ({ onClose }) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div className={classes.container}>
            <Text className={classes.successMessage}>{t('callback.successMessage')}</Text>
            <Button appearance="primary" onClick={onClose}>
                {t('callback.closeButton')}
            </Button>
        </div>
    );
};
